import { render, staticRenderFns } from "./CustomerPoliticallyExposedPerson.vue?vue&type=template&id=86e193c4"
import script from "./CustomerPoliticallyExposedPerson.vue?vue&type=script&lang=js"
export * from "./CustomerPoliticallyExposedPerson.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports